import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import loader from "../../assets/loader.json";
import { useGetSingleUserNftQuery } from "../../redux/features/user/userApi";
import Navbar from "../../Components/Navbar";
import { DataGrid } from "@mui/x-data-grid";
import { styles } from "../../styles/style";
import { FiDownload } from "react-icons/fi";
import * as XLSX from "xlsx";

const StakeHistory = ({ id, canWrite }) => {
    const [nftData, setNftData]=useState();
  
const {isSuccess,data, isLoading}=useGetSingleUserNftQuery(id);


useEffect(()=>{
    if(isSuccess && data.status === true){
      setNftData(data.data)   
    }
},[setNftData,data,isSuccess])
console.log(`nft ${nftData}`)

    const columns = [
        { field: "id", headerName: "S.No",flex:0.25, minWidth: 50 },
        { field: "email", headerName: "Email",flex:1, minWidth: 200 },
        { field: "name", headerName: "User Name",flex:1, minWidth: 200 },
        { field: "quantity", headerName: "Quantity",flex:0.25, minwidth: 50 },
        { field: "project", headerName: "Project",flex:0.5, minWidth: 100 },
        // { field: "project_plan", headerName: "Project Plan",flex:0.5, minWidth: 100 },
        // { field: "project_price", headerName: "Project Price",flex:0.5, minWidth: 100 },
        { field: "createdAt", headerName: "Created At",flex:0.75, minWidth: 200 },
      ];
    
      const rows = [];
      {
        data?.data &&
          data?.data.forEach((item, index) => {
            const options = {
              year: "numeric",
              month: "long",
              day: "numeric",
            };
    
            const date = new Date(item.createdAt).toLocaleDateString(
              "en-US",
              options
            );
            console.log(date);
           
    
            rows.push({
              id: index + 1,
              email: item.useremail,
              name: item.username,
              quantity:item.Quantity,
              project:item.Project,
              project_plan:item.Project_plan,
              project_price:item.Project_price,
              createdAt: date,
            
            });
          });
      }
    
      const style = {
        height: 100,
        width: 100,
        margin: "auto",
        alignItem: "center",
      };
    
      console.log(data);
    
      // Export handler for order history
      const handleExport = () => {
        if (!data?.data) return;
        const exportRows = data.data.map((item, index) => ({
          "S.No": index + 1,
          "Email": item.useremail,
          "User Name": item.username,
          "Quantity": item.Quantity,
          "Project": item.Project,
          // "Project Plan": item.Project_plan,
          // "Project Price": item.Project_price,
          "Created At": new Date(item.createdAt).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
        }));
        const ws = XLSX.utils.json_to_sheet(exportRows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Order History");
        XLSX.writeFile(wb, `Order_History_${id || "user"}.xlsx`);
      };
    
      return isLoading ? (
        <Lottie animationData={loader} style={style} loop={true} width={20} />
      ) : (
        <div className="w-[80vw] mx-auto h-full">
          <div className="w-full  mt-[10px] border">
            <div className="flex justify-between p-5 text-blue-900 font-bold">
              <h1 className=" text-2xl  ">Order History</h1>
              <button
                onClick={handleExport}
                className="flex items-center gap-2 px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded shadow text-sm"
              >
                <FiDownload className="w-5 h-5" /> 
                {/* Export */}
              </button>
            </div>
            <DataGrid columns={columns} rows={rows} />
          </div>
        </div>
      );
}


export default StakeHistory
